import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import type { ComponentProps } from 'react';

type BoxProps = ComponentProps<typeof Box>;

export const TableCell = ({
  children,
  maxWidth,
  minWidth,
  paddingLeft = 'small',
  paddingRight = 'small',
  width,
}: {
  children: React.ReactNode;
  maxWidth?: number;
  minWidth?: number;
  paddingLeft?: BoxProps['paddingLeft'];
  paddingRight?: BoxProps['paddingRight'];
  width?: '100%' | number;
}) => (
  <Box
    component="td"
    paddingY="medium"
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    style={{
      borderTop: `${vars.borderWidth.standard} solid ${vars.borderColor.neutralLight}`,
      maxWidth,
      minWidth,
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      width,
      textWrap: 'wrap',
    }}
  >
    {children}
  </Box>
);
